// extracted by mini-css-extract-plugin
module.exports = {"title":"TitledPaper_title__1f1ue","paper":"TitledPaper_paper__2BMtT"};